import styled, { injectGlobal } from 'styled-components'

import { Col, Row } from '../../../components/Grid'

injectGlobal`
  a {
    text-decoration: none;
    color: ${props => props.theme.palette.primary1Color};
  }

  a:hover {
    color: ${props => props.theme.palette.primary2Color};
  }

  a:visited, a:active {
    color: ${props => props.theme.palette.primary2Color};
  }
`

/**
|--------------------------------------------------
| Login
|--------------------------------------------------
*/
export const WelcomePageWrapper = styled(Row)`
  height: 100vh;
  background-image: linear-gradient(
    194deg,
    ${props => props.theme.palette.gradient1Color},
    ${props => props.theme.palette.gradient2Color}
  );
`

export const CenterCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/layouts/NonAuthenticated/components/styled-components.js